var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('b-modal', {
    attrs: {
      "id": "quoteDeleteModal",
      "size": "md",
      "hide-footer": "",
      "centered": "",
      "modal-class": "quote-delete-modal dep-modal-delete"
    },
    scopedSlots: _vm._u([{
      key: "modal-header",
      fn: function fn() {
        return undefined;
      },
      proxy: true
    }])
  }, [_c('b-container', {
    staticClass: "p-0",
    attrs: {
      "fluid": ""
    }
  }, [_c('div', {
    staticClass: "modal_contentwrapper"
  }, [_c('div', {
    staticClass: "icon-wrapper"
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24"
    }
  }, [_c('g', {
    attrs: {
      "fill": "none"
    }
  }, [_c('path', {
    attrs: {
      "stroke": "currentColor",
      "stroke-width": "1.5",
      "d": "M5.312 10.762C8.23 5.587 9.689 3 12 3s3.77 2.587 6.688 7.762l.364.644c2.425 4.3 3.638 6.45 2.542 8.022S17.786 21 12.364 21h-.728c-5.422 0-8.134 0-9.23-1.572s.117-3.722 2.542-8.022z"
    }
  }), _c('path', {
    attrs: {
      "stroke": "currentColor",
      "stroke-linecap": "round",
      "stroke-width": "1.5",
      "d": "M12 8v5"
    }
  }), _c('circle', {
    attrs: {
      "cx": "12",
      "cy": "16",
      "r": "1",
      "fill": "currentColor"
    }
  })])])]), _c('div', {
    staticClass: "text-wrapper"
  }, [_c('h5', {
    staticClass: "mb-1"
  }, [_vm._v("Delete Quote?")]), _c('p', {
    staticClass: "mb-0"
  }, [_vm._v(" Are you sure you want to delete this Quote? ")])])]), _c('div', {
    staticClass: "button-wrapper"
  }, [_c('button', {
    staticClass: "btn cancel-btn btn-secondary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v(" Cancel ")]), _c('b-button', {
    staticClass: "delete-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.deleteQuote
    }
  }, [_vm._v(" Delete ")])], 1)])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }